module.exports = __webpack_public_path__ + "img/40_00_079_474.42242412.jpg";